var LanguageSelector = window.LanguageSelector = (function () {
    function init(languageContainer) {
        $(document).on('click touch', languageContainer, function (event) {
            event.stopPropagation();

            if ($(event.target).closest('.j-lang-selected-option').length > 0) {
                dropListTrigger(event.currentTarget);
            } else if ($(event.target).closest('.drop-list__items > .option').length > 0) {
                let selectedOption = $(event.target).closest('.option')[0];
                let langContainer = event.currentTarget;

                event.stopPropagation();
                selectLanguage(selectedOption, langContainer);
                closeList(langContainer);
            }
        });

        $(document).on('click', function (e) {
            if ($(e.target).closest(languageContainer).length == 0) {
                closeList(languageContainer);
            }
        });
    }
    //dropList
    function dropListTrigger(triggerEl) {
        let dropListEl = $(".j-lang-selector-drop-list", triggerEl);
        let dropListArrow = $(".j-lang-selector-drop-arrow", triggerEl);

        if (dropListEl.hasClass("active")) {
            dropListEl.removeClass("active");
            dropListArrow.removeClass("open");
        } else {
            dropListEl.addClass("active");
            dropListArrow.addClass("open");
        }
    }

    function closeList(langContainer) {
        let dropListEl = $(".j-lang-selector-drop-list", langContainer);
        let dropListArrow = $(".j-lang-selector-drop-arrow", langContainer);

        dropListEl.removeClass("active");
        dropListArrow.removeClass("open");
    }

    function selectLanguage(selectedOption, langContainer) {
        const langId = $(selectedOption).data('lang');
        const langName = $(selectedOption).text();
        const flagLang = $('.country-flag > img', selectedOption).attr('src');
        $('.j-lang-value', langContainer).val(langId);
        $('.j-lang-selected-option > .country-lang', langContainer).text(langName);
        $('.j-lang-selected-option > .country-flag > .country-flag__image', langContainer).attr('src', flagLang);
        const langIcon = langContainer.querySelector('.icon use');
        if (langIcon) {
            const culture = $(selectedOption).data('culture');
            const iconPath = `${window.globalAppSettings.svg.defaultSprite}#flag-${culture}`;
            langIcon.setAttribute('xlink:href', iconPath);
        }


        $(selectedOption).siblings().removeClass('selected');
        $(selectedOption).addClass('selected');

        Localization.changeLanguage(langId);
    }

    return {
        init
    }
})()

LanguageSelector.init('.j-lang-selector');